import { Info } from 'luxon';
import { RecurringType, RentalProductPrice } from '../../../clients/quipli-service/pricing/pricing';
import { addNumericSuffix, safeRound } from '../../../util/util';

export const translateDaysOfMonth = (daysOfMonth: number[]): string => {
  return daysOfMonth.map((day) => (day === -1 ? 'last' : addNumericSuffix(day))).join(', ');
};

export const translateDaysOfWeek = (dow: number[]): string =>
  dow.length === 7 ? 'week' : dow.map((day) => Info.weekdays('short')[day - 1]).join(', ');

export const translateWeeksOfMonth = (wom: number[]): string =>
  wom.map((week) => (week === -1 ? 'last' : addNumericSuffix(week))).join(', ');

export const pricingFormatter = (
  rpp: RentalProductPrice,
  tagDiscount: number,
  taxInclusivePricing: boolean,
  currencyFormat: Intl.NumberFormat,
  showRangePriceUnits?: boolean | undefined,
) => {
  const fromFormatted = rpp.from?.toFormat('LLLL d, y');
  const toFormatted = rpp.to?.toFormat('LLLL d, y');
  const activeOn =
    rpp.recurringType === RecurringType.Weekly
      ? `Every ${translateDaysOfWeek(rpp.recurringDaysOfWeek!)}`
      : rpp.recurringType === RecurringType.Biweekly
      ? `Every other ${translateDaysOfWeek(rpp.recurringDaysOfWeek!)}`
      : rpp.recurringType === RecurringType.DateMonthly
      ? `Every ${translateDaysOfMonth(rpp.recurringDaysOfMonth!)} of the month`
      : rpp.recurringType === RecurringType.DayOfWeekMonthly
      ? `Every ${translateWeeksOfMonth(rpp.recurringWeeksOfMonth!)} ${translateDaysOfWeek(
          rpp.recurringDaysOfWeek!,
        )} of the month`
      : rpp.from && rpp.to
      ? `${fromFormatted}${fromFormatted === toFormatted ? '' : ` - ${rpp.to.toFormat('LLLL d, y')}`}`
      : 'Every day';
  const duration =
    rpp.durationLabel ??
    `${rpp.durationValue === 1 ? '' : `${rpp.durationValue} `}${rpp.durationUnit}${rpp.durationValue > 1 ? 's' : ''}`;
  const taxPct = taxInclusivePricing ? 1 + (rpp.taxPercentage ? rpp.taxPercentage : 0) / 100 : 1;
  return {
    priceLabel: `$${currencyFormat.format(safeRound((rpp.price * tagDiscount * taxPct) / 100, 2))}${
      rpp.featured ? '' : ` per ${duration}`
    }`,
    durationLabel: showRangePriceUnits ? duration : `Per ${duration}`,
    activeOn,
    featured: rpp.featured,
    price: safeRound(rpp.price * tagDiscount * taxPct, 2),
    durationMinutes: rpp.durationMinutes,
  };
};
